import { BiSolidHotel } from "react-icons/bi";
import {
  FaArrowAltCircleLeft,
  FaBusAlt,
  FaCar,
  FaExchangeAlt,
  FaRegArrowAltCircleLeft,
} from "react-icons/fa";
import { FaTrainSubway } from "react-icons/fa6";
import { GrSchedules } from "react-icons/gr";
import { PiAirplaneTakeoff } from "react-icons/pi";

import bg1 from "../assets/img/bg1.png";
import bg2 from "../assets/img/Uphill travels_Website banner services 2.png";
import bg3 from "../assets/img/Uphill travels_Website banner services 3.png";
import bg4 from "../assets/img/Uphill travels_Website banner services 4.png";

import sec1 from "../assets/img/xx/Uphill travels_Website banner tours 1.png";
import sec2 from "../assets/img/xx/Uphill travels_Website banner tours 2.png";
import sec3 from "../assets/img/xx/Uphill travels_Website banner tours 3.png";
import sec4 from "../assets/img/xx/Uphill travels_Website banner tours 4.png";

import tpbg from "../assets/img/Uphill travels_Website footer banner.png";

// menuData.js
export const headerDataSection = {
  name: "Uphill Travels",
  headertext: [
    {
      title: "deals",
      id: 2,
    },
    {
      title: "support",
      id: 3,
    },
    {
      title: "bookings",
      id: 3,
    },
  ],
  headerButtom: [
    {
      name: "Contact Us",
      id: "1",
    },
    // {
    //   name: "register",
    //   id: "1",
    // },
  ],
};
export const headerTwoSection = {
  name: "header",
  headerTwoSectionButton: [
    {
      title: "hotels",
      id: 1,
      icon: <BiSolidHotel />,
    },
    {
      title: "flights",
      id: 2,
      icon: <PiAirplaneTakeoff />,
    },
    {
      title: "trains",
      id: 3,
      icon: <FaTrainSubway />,
    },
    {
      title: "bus & travel",
      id: 4,
      icon: <FaBusAlt />,
    },
    {
      title: "car rentals",
      id: 5,
      icon: <FaCar />,
    },
    {
      title: "events",
      id: 6,
      icon: <GrSchedules />,
    },
  ],
};
export const MainSection = {
  name: "header",
  text1:
    "where you get trapped in the beauty of the world and unforgettable happiness",
  text2:
    "At Uphill Travels, we believe that every journey is an opportunity for adventure, discovery and unfrogettable experience",
  btntext: "booking Now",

  col2heading: "Find Hotels",
  text1co: "City or Hotel Name",
  text2Col1: "Check in",
  text2Col3: "Duration",
  text2Col3: "Guest and Rooms",
  btntextx: "Search Hotel",
};

export const BigPromoSection = {
  name1: "big",
  name2: "promo",
  text1: "limited time offer book now and save big!",
  text2:
    "Big Promo Alert! Are your ready for the ultimate adventure at unbeatable price? Uphill Travels is thrilled to announce our lastest Big Promo, offering your incredible deals on your dream vacations! ",
  btntext: "book Now",
  imagedata: [
    {
      text1: "Let's Explore Together",
      textimage: <FaRegArrowAltCircleLeft />,
      promo: "",
      bg: bg1,
      text2: "",
    },
    {
      text1: "Our adventure awaits",
      promo: "",
      text2: "",
      textimage: <FaExchangeAlt />,
      bg: bg2,
    },
    {
      text1: "Snowy winter wonderland",
      textimage: <FaRegArrowAltCircleLeft />,
      promo: " ",
      bg: bg3,
      text2: " ",
    },
    {
      text1: "Flight next week",
      promo: " ",
      textimage: <FaRegArrowAltCircleLeft />,
      bg: bg4,
      text2: " ",
    },
  ],
};

export const bannerSection = {
  text1: "Ready to embark on your next",
  text2: "adventure? Connect with Uphill Travels today",
  text3: "to start planning your dream trip",
  bttex: "Booking Now",
};
export const recommendSection = {
  name: "Recommeded for you",
  text2: "I hope you find these",
  text2x: "recommedations enjoyable",
  array: [
    {
      title: "Surfing at Sundak",
      price: 250.0,
      description: " .",
      action: "",
      bg: sec1,
    },
    {
      title: "Rafting at Progo",
      price: 125.0,
      description: "Experience stunning sunsets, white-washed waters.",
      action: "Booking Trip",
      bg: sec2,
    },
    {
      title: "Baturaden Bobocabin",
      price: 150.0,
      description: "Experience stunning sunsets, white-washed.",
      action: "Booking Trip",
      bg: sec3,
    },
    {
      title: "Dieng Villa View",
      price: 750.0,
      description: "Experience stunning sunsets, white-washed.",
      action: "Booking Trip",
      bg: sec4,
    },
  ],
};

export const BestSection = {
  title: "Best Event for 2024",
  title2:
    "Join us for an unforgettable experience at the most anticipated event of the year. Discover the magic and excitement that awaits you.",

  span: " Carnevale",
  span1: " at Venesla",
  btnText: "Booking Ticket",
  bg: tpbg,
  // text1:
  //   "Experience the vibrant atmosphere of Carnevale at Venesla, where tradition meets modern celebration. Enjoy parades, music, and exquisite costumes that bring the streets to life.",
  // text2: "Don't miss out on the chance to be part of this spectacular event. ",
  // text3: "Book your tickets now and join us for an unforgettable celebration.",
};

export const AboutSection = {
  name1: "about",
  name2: "us",
  text1:
    "where you get trapped in the beauty of the world and unforgettable happiness",
  text2:
    "Big Promo Alert! Are your ready for the ultimate adventure at unbeatable price? Uphill Travels is thrilled to announce our lastest Big Promo, offering your incredible deals on your dream vacations! ",
  btntext: "book Now",
  imagedata: [
    {
      text1: "",
      text1: "",
      textimage: "",
    },
    {
      text1: "",
      text1: "",
      textimage: "",
    },
    {
      text1: "",
      text1: "",
      textimage: "",
    },
    {
      text1: "",
      text1: "",
      textimage: "",
    },
  ],
};
